// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const environmentCommonFields = {
  code: "编号",
  name: "名称",
  displayName: "显示名",
  category: "分类",
  architecture: "架构",
  status: "状态",
  visibility: "可见性",
  shareMode: "共享方式",
  usageType: "用途",
  source: "来源",
  actions: "操作",
  description: "说明",
  tags: "标签",
  createdAt: "创建时间",
  assetId: "资产 ID",
  declaredQemuGuestAgent: "qemu-guest-agent 镜像内置",
  declaredAirangeVmAgent: "手工声明已预装 airange-vm-agent",
  declarationScope: "声明口径",
  filename: "文件名",
  objectSpace: "对象空间",
  contentType: "内容类型",
  fileSize: "文件大小",
  declaredPorts: "声明端口",
  defaultAccessPorts: "默认访问端口",
  transportProtocol: "传输协议",
  guestPort: "Guest 端口",
  serviceProtocol: "服务协议",
  portLabel: "端口名称",
} as const;
